import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ModuleWithProviders } from '@angular/core';

import { MotesLoginService } from './motes-login.service';
import { MotesLoginComponent } from './motes-login.component';
import { MotesLoginComponentOverlay } from './motes-login-overlay.component';
import { SvgIconModule } from '../components/svg-icon/svg-icon.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule
    ],
    declarations: [
        MotesLoginComponent,
        MotesLoginComponentOverlay
    ],
    exports: [
        MotesLoginComponent,
        MotesLoginComponentOverlay
    ]
})

export class MotesLoginModule {
    // Ensure that only one instance of login service is instantiated
    static forRoot(): ModuleWithProviders<MotesLoginModule> {
        return {
            ngModule: MotesLoginModule,
            providers: [
                MotesLoginService
            ]
        };
    }
}
